<template>
    <v-col
        :class="$vuetify.breakpoint.smAndDown ? 'pl-4 pr-1' : 'px-0'"
        class="pb-1 pt-0"
    >
        <!--                :pagination.sync="options"-->
        <ModernFilterBar
            v-if="mobileShowFilterbar"
            :filter-controller="filterController"
        >
            <template v-slot:right="{filters, filterAdd}">
                <AddFilterButton
                    :filters="filters"
                    @add_filter="filterAdd($event)"
                />
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <icon-button
                            :on="on"
                            icon="Delete"
                            @click="filterController.resetFilters()"
                        />
                    </template>
                    <span>{{ $t("Clear filters") }}</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <icon-button
                            :on="on"
                            icon="Save"
                            @click="onSaveFiltersClick"
                        />
                    </template>
                    <span>{{ $t("Save filters") }}</span>
                </v-tooltip>
            </template>
        </ModernFilterBar>
    </v-col>
</template>

<script>
import ModernFilterBar from "../../../components/ModernFilterBar";
import AddFilterButton from "../../../components/ModernFilterBar/components/AddFilterButton";
import ColumnController from "../../../components/ColumnController";
import { computed, ref } from "@vue/composition-api";
import BookmarkModule from "../../../store/modules/bookmark";
import { Router } from "../../../composables/Router";
import AppModule from "../../../store/modules/app";
import { $t } from "../../../i18n";
import DialogModule from "../../../store/modules/dialog";
import ClientModule from "../../../store/modules/client"

export default {
    name: "FilterSection",
    components: {
        ModernFilterBar,
        AddFilterButton,
        ColumnController
    },
    props: {
        filterController: {
            type: Object,
            required: true
        },
        mobileShowFilterbar: {
            type: Boolean,
            required: true
        }
    },
    setup(props, ctx) {
        const { client_bookmarks } = BookmarkModule();
        const { setDialogOptions, openDialog } = DialogModule();

        const onSaveFiltersClick = () => {
            setDialogOptions({
                component: () => import("@/views/Dialog/BookmarkDialog"),
                payload: {
                    type: "client"
                }
            });
            openDialog();
        };

        return {
            client_bookmarks,
            onSaveFiltersClick,
        }
    }
}
</script>

<style scoped>

</style>